export const scrollToTop = () => window.scroll(0, 0);

export const BASE_URL = "";
